import { render } from "./ItemsDetail.vue?vue&type=template&id=73ffc5f4&scoped=true"
import script from "./ItemsDetail.vue?vue&type=script&lang=js"
export * from "./ItemsDetail.vue?vue&type=script&lang=js"

import "./ItemsDetail.vue?vue&type=style&index=0&id=73ffc5f4&scoped=true&lang=css"
import "./ItemsDetail.vue?vue&type=style&index=1&id=73ffc5f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ffc5f4"]])

export default __exports__